export const APIAdminColumnImportList = [
    'BoardMident',
    'SchoolMident',
    'SchoolName',
    'PrincipalEmail',
    'PrincipalFirstName',
    'PrincipalLastName',
  ]